import {
  DeleteOutlined,
  PlusOutlined,
  LinkOutlined,
  MailOutlined,
  EditOutlined,
  NodeIndexOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { message, Row, Col, Spin, PageHeader, Space, Tag, Empty, Select, Upload } from "antd";
import React, { Component } from "react";
import axios from "axios";
import moment from "moment";
import { connect } from "react-redux";
import {
  Form,
  FormItem,
  InputItem,
  InputNumberItem,
  TextAreaItem,
  CheckItem,
  DatePickerItem,
  SelectItem,
  ButtonItem,
  ErrorItem,
} from "../../../../../Components/Items";
import DynamicCardForm from "../../../../../Components/DynamicCardForm";
import GrupoCasillasItem from "../../../../../Components/GrupoCasillasItem";
import CasillasExclusivasItem, { OPCIONES_RECOLECCION_ENTREGA } from "../../../../../Components/CasillasExclusivasItem";
import ModalPrevisualizarArchivos from "../../../../../Components/ModalPrevisualizarArchivos";
import SeguimientoOrdenDeMaquila from "../SeguimientoOrdenDeMaquila/SeguimientoOrdenDeMaquila";
import MandarCorreoOrdenDeMaquila from "../MandarCorreoOrdenDeMaquila/MandarCorreoOrdenDeMaquila";

const TOLERANCIA_ESTANDAR = "TOLERANCIA ESTANDAR +-.5mm";

const ETIQUETA_ESTADO = {
  0: { texto: "Cancelada", color: "red" },
  1: { texto: "Abierta", color: "blue" },
  2: { texto: "En proceso", color: "orange" },
  3: { texto: "Terminada", color: "green" },
};

const FECHAS = ["fechaSolicitud", "fechaCompromiso", "fechaRecoleccion", "fechaEntrega"];

const { Option } = Select;

/*
  `tipoTolerancia` es solo de pantalla y no se guarda: la tolerancia especial sigue
  viviendo en `toleranciaEspecial` (vacía = estándar, que es como la lee el PDF). Así las
  órdenes que ya existen se leen igual: con texto son "Especial", sin texto "Estándar".
*/
const prepararMateriales = (materiales = []) =>
  materiales.map((material) => ({
    ...material,
    tipoTolerancia: (material?.toleranciaEspecial || "").trim() ? "especial" : "estandar",
  }));

const materialParaGuardar = ({ tipoTolerancia, ...material }) => ({
  ...material,
  toleranciaEspecial: tipoTolerancia === "especial" ? (material.toleranciaEspecial || "").trim() : "",
});

/*
  Archivos de la orden (planos, DXF/DWG, Excel, fotos). Viven en this.state.archivos y no
  en el form: un FormItem con name sobre un Upload guarda el evento de antd, no la lista.
  Los nuevos traen `originFileObj` y se mandan en base64 al guardar; los guardados se
  hidratan SIN `url` (con `urlRelativa`) para que el modal de vista previa los pida al
  backend en lugar de tratarlos como liga externa.
*/
const LIMITE_ARCHIVO_MB = 20;
const EXTENSIONES_PREVISUALIZABLES = ["pdf", "png", "jpg", "jpeg", "webp", "gif"];
const ENDPOINT_ARCHIVO = "ordenesDeMaquila/obtenerArchivoOrdenDeMaquilaBase64";

const extensionDe = (nombre = "") => (nombre.includes(".") ? nombre.split(".").pop().toLowerCase() : "");

const getBase64 = (archivo) =>
  new Promise((resolve, reject) => {
    const lector = new FileReader();
    lector.readAsDataURL(archivo);
    lector.onload = () => resolve(lector.result);
    lector.onerror = reject;
  });

const descargarBlob = (blob, nombre) => {
  const url = URL.createObjectURL(blob);
  const enlace = document.createElement("a");
  enlace.href = url;
  enlace.download = nombre || "archivo";
  enlace.click();
  URL.revokeObjectURL(url);
};

const archivosDesdeBackend = (archivos = []) =>
  archivos.map((archivo, indice) => ({
    uid: `guardado-${indice}-${archivo.url}`,
    name: archivo.name,
    status: "done",
    cargadoDesdeBackend: true,
    urlRelativa: archivo.url,
  }));

/*
  Modo determinado por location.state:
    - Sin id y sin preCotizacionId  → Agregar en blanco
    - { preCotizacionId }           → Agregar precargada desde esa pre cotización
    - { id, modo: "editar" }        → Editar
    - { id, modo: "ver" }           → Ver (solo lectura)
*/
class VistaOrdenDeMaquila extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    folio: "",
    estado: null,
    preCotizacionId: null,
    modalSeguimientoVisible: false,
    modalCorreoVisible: false,
    archivos: [],
    archivoVer: null,
  };

  get modo() {
    return this.props.location?.state?.modo || "agregar";
  }

  get id() {
    return this.props.location?.state?.id || null;
  }

  get preCotizacionIdOrigen() {
    return this.props.location?.state?.preCotizacionId || null;
  }

  // Serie y folio que se sugirieron al abrir el alta. Si el usuario no los toca no se
  // mandan y el backend toma el consecutivo: asi no choca si otro guardo antes.
  folioSugerido = null;

  // La orden que nace de una pre cotizacion lleva su numero con la serie de ordenes
  // (PC 739 → OM-739). El borrador
  // y el consecutivo se piden en paralelo: esta bandera evita que el consecutivo pise el
  // folio de la pre cotizacion si su respuesta llega despues.
  folioDesdePreCotizacion = false;

  componentDidMount() {
    if (this.id) {
      this.consultarOrden();
      return;
    }
    if (this.preCotizacionIdOrigen) {
      this.consultarBorrador();
    } else {
      this.formRef.current.setFieldsValue({ materiales: prepararMateriales([{}]) });
    }
    this.consultarSiguienteFolio();
  }

  consultarSiguienteFolio() {
    axios
      .post(
        "ordenesDeMaquila/siguienteFolio",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success !== 2) return;
        this.folioSugerido = { serie: res.data.serie, numero: res.data.numero };
        if (!this.folioDesdePreCotizacion) this.formRef.current?.setFieldsValue(this.folioSugerido);
      });
  }

  // DatePickerItem es de antd v4 y trabaja con moment: si se le pasa la cadena ISO tal
  // como viene del backend truena al abrir el calendario.
  aMoment(valores) {
    const convertidas = {};
    FECHAS.forEach((campo) => {
      convertidas[campo] = valores?.[campo] ? moment(valores[campo]) : undefined;
    });
    return convertidas;
  }

  consultarOrden() {
    this.setState({ loading: true });
    axios
      .post(
        "ordenesDeMaquila/datosOrdenDeMaquila",
        { empresaId: this.props.empresaId, ordenDeMaquilaId: this.id },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success !== 2) {
          message.error("No se encontró la orden de maquila");
          return;
        }
        this.setState({
          folio: res.data.folio || "",
          estado: res.data.estado,
          preCotizacionId: res.data.preCotizacionId || null,
          archivos: archivosDesdeBackend(res.data.archivos || []),
        });
        this.formRef.current.setFieldsValue({
          ...res.data,
          ...this.aMoment(res.data),
          materiales: prepararMateriales(res.data.materiales || []),
        });
      });
  }

  consultarBorrador() {
    this.setState({ loading: true });
    axios
      .post(
        "ordenesDeMaquila/borradorDesdePreCotizacion",
        { empresaId: this.props.empresaId, preCotizacionId: this.preCotizacionIdOrigen },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success !== 2) {
          message.error("No se encontró la pre cotización");
          return;
        }
        const borrador = res.data.borrador;
        this.setState({ preCotizacionId: borrador.preCotizacionId });
        // Con serie/numero el borrador trae el folio de la pre cotizacion y manda sobre el
        // consecutivo. Sin ellos (ya lo tomo otra orden) el setFieldsValue no toca el folio
        // y se queda el consecutivo, llegue antes o despues.
        if (borrador.serie && borrador.numero) this.folioDesdePreCotizacion = true;
        this.formRef.current.setFieldsValue({
          ...borrador,
          ...this.aMoment(borrador),
          materiales: prepararMateriales(borrador.materiales || [{}]),
        });
        message.success("Se precargaron los datos de la pre cotización");
        if (res.data.folioPreCotizacionOcupado) {
          message.info(
            `Ya existe la orden de maquila ${res.data.folioPreCotizacionOcupado}; se propone el siguiente consecutivo.`
          );
        }
      });
  }

  atras() {
    this.props.history.goBack();
  }

  editar() {
    this.props.history.replace("/panel/vistaOrdenDeMaquila", { id: this.id, modo: "editar" });
  }

  verPreCotizacion() {
    this.props.history.push("/panel/vistaPreCotizacionIngenieria", {
      id: this.state.preCotizacionId,
      modo: "ver",
    });
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  // Antes de agregarlo a la lista: el Upload no sube nada solo (regresa false) y lo que
  // pasa del limite ni se lista.
  agregarArchivo = (archivo) => {
    if (archivo.size / (1024 * 1024) > LIMITE_ARCHIVO_MB) {
      message.error(`${archivo.name} pesa más de ${LIMITE_ARCHIVO_MB} MB`);
      return Upload.LIST_IGNORE;
    }
    // setState funcional: con selección múltiple esto se llama una vez por archivo.
    this.setState((anterior) => ({
      archivos: [...anterior.archivos, { uid: archivo.uid, name: archivo.name, status: "done", originFileObj: archivo }],
    }));
    return false;
  };

  quitarArchivo = (archivo) => {
    this.setState((anterior) => ({ archivos: anterior.archivos.filter((item) => item.uid !== archivo.uid) }));
  };

  // PDF e imágenes se ven en el modal; lo demás (DXF, DWG, Excel) no tiene vista previa y
  // se descarga directo.
  verArchivo = (archivo) => {
    if (EXTENSIONES_PREVISUALIZABLES.includes(extensionDe(archivo.name))) {
      this.setState({ archivoVer: archivo });
    } else {
      this.descargarArchivo(archivo);
    }
  };

  descargarArchivo = (archivo) => {
    if (archivo.originFileObj) {
      descargarBlob(archivo.originFileObj, archivo.name);
      return;
    }
    axios
      .post(
        ENDPOINT_ARCHIVO,
        { empresaId: this.props.empresaId, ordenDeMaquilaId: this.id, archivoPath: archivo.urlRelativa },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success !== 2 || !res.data.base64) {
          message.error("No se pudo descargar el archivo");
          return;
        }
        const bytes = Uint8Array.from(atob(res.data.base64), (caracter) => caracter.charCodeAt(0));
        descargarBlob(new Blob([bytes], { type: res.data.mime }), archivo.name || res.data.name);
      })
      .catch(() => message.error("No se pudo descargar el archivo"));
  };

  // Lo nuevo va en base64; lo ya guardado, con su ruta relativa para que el backend lo
  // reconozca y no lo borre.
  archivosParaGuardar() {
    return Promise.all(
      this.state.archivos.map(async (archivo) =>
        archivo.originFileObj
          ? { name: archivo.name, url: await getBase64(archivo.originFileObj) }
          : { name: archivo.name, url: archivo.urlRelativa }
      )
    );
  }

  async onFinish(values) {
    this.setState({ loading: true });
    const esEditar = this.modo === "editar";

    const { serie, numero, materiales, ...resto } = values;
    const sinCambiarFolio =
      !esEditar &&
      this.folioSugerido &&
      (serie || "").trim() === this.folioSugerido.serie &&
      numero === this.folioSugerido.numero;

    let archivos;
    try {
      archivos = await this.archivosParaGuardar();
    } catch (error) {
      this.setState({ loading: false });
      message.error("No se pudieron leer los archivos adjuntos");
      return;
    }

    axios
      .post(
        esEditar ? "ordenesDeMaquila/editarOrdenDeMaquila" : "ordenesDeMaquila/agregarOrdenDeMaquila",
        {
          ...resto,
          ...(sinCambiarFolio ? {} : { serie, numero }),
          materiales: (materiales || []).map(materialParaGuardar),
          archivos,
          empresaId: this.props.empresaId,
          ...(esEditar
            ? { ordenDeMaquilaId: this.id }
            : {
                preCotizacionId: this.preCotizacionIdOrigen || undefined,
                cotizacionId: values.cotizacionId || undefined,
              }),
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success(
            esEditar ? "Se ha editado la orden de maquila" : `Se ha registrado la orden de maquila ${res.data.folio || ""}`
          );
          if (esEditar) {
            this.atras();
          } else {
            this.props.history.push("/panel/ordenesDeMaquila");
          }
        } else if (res.data.success === 1) {
          message.error(res.data.message || "No se pudo guardar la orden de maquila");
        } else {
          message.error("Hubo un error y la orden de maquila no se guardó");
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Hubo un error y la orden de maquila no se guardó");
      });
  }

  renderMaterial(field, remove, soloLectura, total) {
    const { key, name, ...restField } = field;

    // shouldUpdate acotado a un solo campo: el título del recuadro muestra el material
    // para que las tarjetas plegadas sigan siendo legibles, sin volver a pintar la lista
    // entera en cada tecla.
    return (
      <FormItem
        key={key}
        noStyle
        shouldUpdate={(anterior, actual) =>
          anterior?.materiales?.[name]?.material !== actual?.materiales?.[name]?.material
        }
      >
        {({ getFieldValue }) => {
          const nombreMaterial = (getFieldValue(["materiales", name, "material"]) || "").trim();

          return (
            <DynamicCardForm
              title={`Material #${name + 1}${nombreMaterial ? ` · ${nombreMaterial}` : ""}`}
              marginBottom={12}
              collapsable
              compact
              // Va dentro de la tarjeta "Materiales": con la misma sombra las dos cajas
              // compiten. El recuadro del material queda subordinado, con borde y fondo
              // apenas más frío.
              style={{ boxShadow: "none", border: "1px solid #f0f0f0", background: "#fcfcfd" }}
              headerRight={
                !soloLectura && total > 1 ? (
                  <ButtonItem
                    type="default"
                    size="small"
                    rojo
                    icon={<DeleteOutlined />}
                    onClick={() => remove(name)}
                  >
                    Quitar
                  </ButtonItem>
                ) : null
              }
            >
              <FormItem {...restField} name={[name, "_id"]} hidden>
                <InputItem />
              </FormItem>

              <Row gutter={16}>
                <Col xs={24} md={10}>
                  <FormItem {...restField} label="Material" name={[name, "material"]} margin>
                    <InputItem placeholder="PTR 2x2, placa 3/8…" disabled={soloLectura} />
                  </FormItem>
                </Col>
                <Col xs={12} md={7}>
                  <FormItem {...restField} label="Calibre" name={[name, "calibre"]} margin>
                    <InputItem placeholder="Calibre" disabled={soloLectura} />
                  </FormItem>
                </Col>
                <Col xs={12} md={7}>
                  <FormItem {...restField} label="Dimensiones" name={[name, "dimensiones"]} margin>
                    <InputItem placeholder="1220 x 2440" disabled={soloLectura} />
                  </FormItem>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col xs={24}>
                  <FormItem {...restField} label="Procesos" name={[name, "procesos"]} margin>
                    <TextAreaItem
                      placeholder="Corte láser, doblez, soldadura…"
                      rows={2}
                      disabled={soloLectura}
                    />
                  </FormItem>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col xs={24} md={12}>
                  <FormItem {...restField} label="Cantidad de material" name={[name, "cantidad"]} margin>
                    <InputItem placeholder="3 hojas, 12 m…" disabled={soloLectura} />
                  </FormItem>
                </Col>
                <Col xs={24} md={12}>
                  <FormItem {...restField} label="Cantidad de piezas" name={[name, "cantidadPiezas"]} margin>
                    <InputNumberItem placeholder="0" style={{ width: "100%" }} disabled={soloLectura} />
                  </FormItem>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col xs={24} md={8}>
                  <FormItem
                    {...restField}
                    label="Tolerancia"
                    name={[name, "tipoTolerancia"]}
                    tooltip={{ title: `Estándar imprime "${TOLERANCIA_ESTANDAR}" en el PDF.` }}
                    margin
                  >
                    <SelectItem noBuscar placeholder="Tolerancia" style={{ width: "100%" }} disabled={soloLectura}>
                      <Option value="estandar">Estándar ±0.5 mm</Option>
                      <Option value="especial">Especial</Option>
                    </SelectItem>
                  </FormItem>
                </Col>
                {/* El campo libre solo existe con tolerancia especial; acotado a este
                    material para no repintar la lista en cada tecla. */}
                <FormItem
                  noStyle
                  shouldUpdate={(anterior, actual) =>
                    anterior?.materiales?.[name]?.tipoTolerancia !== actual?.materiales?.[name]?.tipoTolerancia
                  }
                >
                  {({ getFieldValue }) =>
                    getFieldValue(["materiales", name, "tipoTolerancia"]) === "especial" ? (
                      <Col xs={24} md={16}>
                        <FormItem
                          {...restField}
                          label="Tolerancia especial"
                          name={[name, "toleranciaEspecial"]}
                          required={!soloLectura}
                          margin
                        >
                          <InputItem placeholder="+-.2mm" disabled={soloLectura} />
                        </FormItem>
                      </Col>
                    ) : null
                  }
                </FormItem>
              </Row>

              <div style={{ borderTop: "1px dashed #f0f0f0", marginTop: 6, paddingTop: 2 }}>
                <GrupoCasillasItem label="Suministra">
                  <FormItem {...restField} name={[name, "suministroEmpresa"]} valuePropName="checked" noStyle>
                    <CheckItem disabled={soloLectura}>La empresa</CheckItem>
                  </FormItem>
                  <FormItem {...restField} name={[name, "suministroCliente"]} valuePropName="checked" noStyle>
                    <CheckItem disabled={soloLectura}>El cliente</CheckItem>
                  </FormItem>
                </GrupoCasillasItem>

                <GrupoCasillasItem label="Estatus del material">
                  <FormItem {...restField} name={[name, "enPiso"]} valuePropName="checked" noStyle>
                    <CheckItem disabled={soloLectura}>En piso</CheckItem>
                  </FormItem>
                  <FormItem {...restField} name={[name, "enCompra"]} valuePropName="checked" noStyle>
                    <CheckItem disabled={soloLectura}>Compra</CheckItem>
                  </FormItem>
                  <FormItem {...restField} name={[name, "enEsperaCliente"]} valuePropName="checked" noStyle>
                    <CheckItem disabled={soloLectura}>En espera del cliente</CheckItem>
                  </FormItem>
                </GrupoCasillasItem>
              </div>

              <Row gutter={16} style={{ marginTop: 8 }}>
                <Col xs={24}>
                  <FormItem {...restField} label="Notas" name={[name, "notas"]} margin>
                    <TextAreaItem placeholder="Notas del material" rows={2} disabled={soloLectura} />
                  </FormItem>
                </Col>
              </Row>
            </DynamicCardForm>
          );
        }}
      </FormItem>
    );
  }

  render() {
    const modo = this.modo;
    const soloLectura = modo === "ver";
    const etiquetaEstado = ETIQUETA_ESTADO[this.state.estado];

    const titulos = {
      agregar: "Agregar Orden de Maquila",
      editar: `Editar Orden de Maquila${this.state.folio ? ` ( ${this.state.folio} )` : ""}`,
      ver: `Ver Orden de Maquila${this.state.folio ? ` ( ${this.state.folio} )` : ""}`,
    };

    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title={titulos[modo] || "Orden de Maquila"}
          tags={etiquetaEstado ? <Tag color={etiquetaEstado.color}>{etiquetaEstado.texto}</Tag> : null}
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            soloLectura ? (
              <Space>
                {this.state.preCotizacionId && (
                  <ButtonItem type="default" lila icon={<LinkOutlined />} onClick={this.verPreCotizacion.bind(this)}>
                    Ver Pre Cotización
                  </ButtonItem>
                )}
                <ButtonItem
                  type="default"
                  lima
                  icon={<NodeIndexOutlined />}
                  onClick={() => this.setState({ modalSeguimientoVisible: true })}
                >
                  Seguimiento
                </ButtonItem>
                <ButtonItem
                  type="default"
                  gris
                  icon={<MailOutlined />}
                  onClick={() => this.setState({ modalCorreoVisible: true })}
                >
                  Mandar Correo
                </ButtonItem>
                {this.state.estado !== 0 && this.state.estado !== 3 && (
                  <ButtonItem type="primary" cyan onClick={this.editar.bind(this)} icon={<EditOutlined />}>
                    Editar
                  </ButtonItem>
                )}
              </Space>
            ) : null
          }
        />
        <Spin spinning={this.state.loading}>
          {/* layoutForm="vertical" en lugar de la prop `layout` de la casa (que fija
              labelCol span 8): la etiqueta va arriba del campo, y asi no se trunca
              dentro de las columnas angostas de las tarjetas. */}
          <Form
            ref={this.formRef}
            name="VistaOrdenDeMaquila"
            layoutForm="vertical"
            onFinish={this.onFinish.bind(this)}
            onFinishFailed={this.onFinishFailed}
          >
            <Row gutter={16}>
              <DynamicCardForm title="Encabezado" xs={24} lg={12} xl={12}>
                {/* Sin un FormItem el cotizacionId del borrador nunca llegaba a onFinish:
                    el form solo entrega los campos registrados. */}
                <FormItem name="cotizacionId" hidden>
                  <InputItem />
                </FormItem>
                <Row gutter={16}>
                  <Col xs={12}>
                    <FormItem label="Serie" name="serie" required={!soloLectura} margin>
                      <InputItem placeholder="OM" disabled={soloLectura} />
                    </FormItem>
                  </Col>
                  <Col xs={12}>
                    <FormItem
                      label="Folio"
                      name="numero"
                      required={!soloLectura}
                      tooltip={{ title: "Se sugiere el siguiente consecutivo; se puede cambiar si no está ocupado." }}
                      margin
                    >
                      <InputNumberItem placeholder="1" min={1} precision={0} style={{ width: "100%" }} disabled={soloLectura} />
                    </FormItem>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col xs={24}>
                    <FormItem label="Nombre del proyecto" name="nombreProyecto" required={!soloLectura} margin>
                      <InputItem placeholder="Nombre del proyecto" disabled={soloLectura} />
                    </FormItem>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col xs={24} md={12}>
                    <FormItem label="Encargado" name="encargadoProyecto" margin>
                      <InputItem placeholder="Quién lo lleva" disabled={soloLectura} />
                    </FormItem>
                  </Col>
                  <Col xs={24} md={12}>
                    <FormItem
                      label="Núm. de cotización"
                      name="numeroCotizacion"
                      tooltip={{ title: "Se hereda de la cotización ligada a la pre cotización." }}
                      margin
                    >
                      <InputItem placeholder="Núm. de cotización" disabled={soloLectura} />
                    </FormItem>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col xs={24} md={12}>
                    <FormItem label="Cliente" name="cliente" margin>
                      <InputItem placeholder="Cliente" disabled={soloLectura} />
                    </FormItem>
                  </Col>
                  <Col xs={24} md={12}>
                    <FormItem label="Contacto" name="contacto" margin>
                      <InputItem placeholder="Con quién se ve" disabled={soloLectura} />
                    </FormItem>
                  </Col>
                </Row>
              </DynamicCardForm>

              <DynamicCardForm title="Fechas" xs={24} lg={12} xl={12}>
                <GrupoCasillasItem label="Programación de entrega">
                  <FormItem name="recoleccionOEntrega" noStyle>
                    <CasillasExclusivasItem opciones={OPCIONES_RECOLECCION_ENTREGA} disabled={soloLectura} />
                  </FormItem>
                </GrupoCasillasItem>
                <Row gutter={16}>
                  <Col xs={12}>
                    <FormItem label="Solicitud" name="fechaSolicitud" margin>
                      <DatePickerItem placeholder="Solicitud" style={{ width: "100%" }} disabled={soloLectura} />
                    </FormItem>
                  </Col>
                  <Col xs={12}>
                    <FormItem label="Compromiso" name="fechaCompromiso" margin>
                      <DatePickerItem placeholder="Compromiso" style={{ width: "100%" }} disabled={soloLectura} />
                    </FormItem>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col xs={12}>
                    <FormItem
                      label="Recolección"
                      name="fechaRecoleccion"
                      tooltip={{ title: "Cuándo se recoge el material." }}
                      margin
                    >
                      <DatePickerItem placeholder="Recolección" style={{ width: "100%" }} disabled={soloLectura} />
                    </FormItem>
                  </Col>
                  <Col xs={12}>
                    <FormItem
                      label="Entrega"
                      name="fechaEntrega"
                      tooltip={{ title: "Cuándo se entrega lo maquilado." }}
                      margin
                    >
                      <DatePickerItem placeholder="Entrega" style={{ width: "100%" }} disabled={soloLectura} />
                    </FormItem>
                  </Col>
                </Row>
              </DynamicCardForm>

              <Form.List name="materiales">
                {(fields, { add, remove }) => (
                  <DynamicCardForm title={`Materiales${fields.length ? ` (${fields.length})` : ""}`} xs={24}>
                    {soloLectura && fields.length === 0 && (
                      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Sin materiales" />
                    )}
                    {fields.map((field) => this.renderMaterial(field, remove, soloLectura, fields.length))}
                    {!soloLectura && (
                      <ButtonItem
                        type="dashed"
                        onClick={() => add(prepararMateriales([{}])[0])}
                        block
                        icon={<PlusOutlined />}
                      >
                        Agregar material
                      </ButtonItem>
                    )}
                  </DynamicCardForm>
                )}
              </Form.List>

              <DynamicCardForm title="Notas finales" xs={24}>
                <FormItem name="notas" margin>
                  <TextAreaItem
                    placeholder="Lo que el piso tiene que saber y no cabe en un material"
                    rows={3}
                    disabled={soloLectura}
                  />
                </FormItem>
              </DynamicCardForm>

              {/* Fuera de cualquier FormItem con name: la lista vive en el state. */}
              <DynamicCardForm title={`Archivos${this.state.archivos.length ? ` (${this.state.archivos.length})` : ""}`} xs={24}>
                {soloLectura && this.state.archivos.length === 0 && (
                  <div style={{ color: "#999" }}>Sin archivos</div>
                )}
                <Upload
                  multiple
                  fileList={this.state.archivos}
                  beforeUpload={this.agregarArchivo}
                  onRemove={this.quitarArchivo}
                  onPreview={this.verArchivo}
                  onDownload={this.descargarArchivo}
                  showUploadList={{ showRemoveIcon: !soloLectura, showDownloadIcon: true }}
                >
                  {!soloLectura && (
                    <ButtonItem type="dashed" icon={<UploadOutlined />}>
                      Adjuntar archivos
                    </ButtonItem>
                  )}
                </Upload>
                {!soloLectura && (
                  <div style={{ color: "#8c8c8c", fontSize: 12, marginTop: 6 }}>
                    Planos (DXF, DWG), PDF, imágenes, Excel… hasta {LIMITE_ARCHIVO_MB} MB cada uno. PDF e
                    imágenes se pueden ver aquí; lo demás se descarga.
                  </div>
                )}
              </DynamicCardForm>
            </Row>

            {!soloLectura && (
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 10,
                  justifyContent: "flex-end",
                  padding: "14px 16px",
                  background: "white",
                  borderRadius: 8,
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
                }}
              >
                <ButtonItem type="default" danger onClick={this.atras.bind(this)}>
                  Cancelar
                </ButtonItem>
                <ButtonItem type="primary" htmlType="submit">
                  {modo === "editar" ? "Guardar cambios" : "Crear orden"}
                </ButtonItem>
              </div>
            )}
          </Form>
        </Spin>
        <SeguimientoOrdenDeMaquila
          visible={this.state.modalSeguimientoVisible}
          id={this.id}
          onCerrar={(huboCambios) => {
            this.setState({ modalSeguimientoVisible: false });
            if (huboCambios) this.consultarOrden();
          }}
        />
        <MandarCorreoOrdenDeMaquila
          visible={this.state.modalCorreoVisible}
          id={this.id}
          onCerrar={() => this.setState({ modalCorreoVisible: false })}
        />
        <ModalPrevisualizarArchivos
          visible={!!this.state.archivoVer}
          file={this.state.archivoVer}
          endpointArchivo={ENDPOINT_ARCHIVO}
          parametrosArchivo={{ ordenDeMaquilaId: this.id }}
          onClose={() => this.setState({ archivoVer: null })}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(VistaOrdenDeMaquila);
